import { View } from 'backbone.marionette';
import { User } from '../../models';
import { ErrorsModal, Secret } from '../../utils';
import Radio from 'backbone.radio';

const
	menuChannel  = Radio.channel( 'menu' ),
	adsChannel    = Radio.channel( 'ads' );
const appViewChannel = Radio.channel('appView');

const isMobileView = () => {
	if ( 'matchMedia' in window ) {
		return window.matchMedia( "(max-width: 999px)" ).matches;
	}

	return false;
};

class CoreMenuView extends View {

	get className() {
		const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON);
		const preseason_class = IS_PRE_SEASON ? "pre-season-menu" : "";
		return 'menu-block '+ preseason_class;
	}

	ui() {
		return {
			open_main_menu: '.js-open-main-menu',
			close_menu:     '.js-close-menu',
			main_menu:      '.js-main-menu',
			log_out:        '.js-log-out',
			menu_item:      '.js-menu-item',
			show_message:   '.js-show-message'
		};
	}

	events() {
		return {
			'click @ui.open_main_menu': 'openMainMenu',
			'click @ui.close_menu':     'closeMainMenu',
			'click @ui.log_out':        'logOut',
			'click @ui.menu_item':      'hideMenuWidget',
			'click @ui.show_message': 'showMessage'
		};
	}

	initialize() {
		this.user = User;
		this.initListeners().initMenu();
		this.model.set({
			is_last_round_started: false,
		});
		if (this.options.rounds) {
			this.options.rounds.fetch().then(() => {
				const is_last_round_started = this.options.rounds.is_last_round_started;

				this.model.set({
					is_last_round_started
				});
				menuChannel.trigger('update:menu');
			});
		}
	}

	initListeners() {
		this.listenTo( menuChannel, 'update:menu', this.render );
		this.listenTo( menuChannel, 'menu:open', this.openMainMenu );
		this.listenTo( menuChannel, 'init:menu', this.showMenu );
		this.listenTo( appViewChannel, 'hide', this.destroy );
		return this;
	}

	initMenu() {
		this.model.setMenu( this.options );
		return this;
	}

	openMainMenu() {
		let time_spead = this.getSpeadShowMenu();

		this.getUI( 'main_menu' ).animate( {
			left: '0'
		}, time_spead );
	}

	closeMainMenu() {
		let time_spead = this.getSpeadShowMenu();

		this.getUI( 'main_menu' ).animate( {
			left: '-105%'
		}, time_spead );
	}

	showMenu( data ) {
		this.model.setMenu( data );
		this.render();
	}

	getSpeadShowMenu() {
		return (isMobileView()) ? 500: 700;
	}

	hideMenuWidget() {
		adsChannel.trigger('destroy-ads');
		this.closeMainMenu();
	}

	logOut() {
		this.user.logout();
	}

	showMessage(e) {
		const { message } = e.currentTarget.dataset;
		ErrorsModal.show(message);
	}

}

export default CoreMenuView;